export const TechLines = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-30 z-0">
      {/* Horizontal Lines - Static on mobile */}
      <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-neon-glow to-transparent md:animate-pulse" />
      <div 
        className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-radiant-blue to-transparent md:animate-pulse" 
        style={{ animationDelay: "1s" }}
      />
      <div 
        className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-neon-glow to-transparent md:animate-pulse" 
        style={{ animationDelay: "2s" }}
      />
      
      {/* Vertical Lines */}
      <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-neon-glow/50 to-transparent" />
      <div className="absolute top-0 left-3/4 w-px h-full bg-gradient-to-b from-transparent via-radiant-blue/50 to-transparent" />
      
      {/* Corner Elements */}
      <div className="absolute top-8 left-8 w-16 h-16 border-t-2 border-l-2 border-neon-glow/50" />
      <div className="absolute top-8 right-8 w-16 h-16 border-t-2 border-r-2 border-neon-glow/50" />
      <div className="absolute bottom-8 left-8 w-16 h-16 border-b-2 border-l-2 border-neon-glow/50" />
      <div className="absolute bottom-8 right-8 w-16 h-16 border-b-2 border-r-2 border-neon-glow/50" />
      
      {/* Glowing Nodes - Desktop only */}
      <div className="hidden md:block absolute top-1/4 left-1/2 w-2 h-2 rounded-full bg-neon-glow shadow-[0_0_20px_hsl(199,100%,58%)] animate-glow-pulse" />
      <div 
        className="hidden md:block absolute top-1/2 left-1/4 w-2 h-2 rounded-full bg-radiant-blue shadow-[0_0_20px_hsl(207,99%,40%)] animate-glow-pulse" 
        style={{ animationDelay: "1s" }}
      />
      <div 
        className="hidden md:block absolute top-3/4 right-1/3 w-2 h-2 rounded-full bg-neon-glow shadow-[0_0_20px_hsl(199,100%,58%)] animate-glow-pulse" 
        style={{ animationDelay: "2s" }}
      />
    </div>
  );
};
